module.exports = {"LOGIN":{"LOGIN_BUTTON":"ACCEDI","USERNAME":"E-mail","PASSWORD":"Password","LOGIN_MIN_LENGTH":"La lunghezza minima è di 3 caratteri.","LOGIN_MAX_LENGTH":"La lunghezza massima è di 50 caratteri.","PASSWORD_MAX_LENGTH":"La lunghezza massima è di 50 caratteri.","EXPIRED_LOGOUT":"La tua sessione è scaduta. Accedi di nuovo."}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/it/login.json
// module id = 716
// module chunks = 0